import { createFeatureSelector, createSelector } from '@ngrx/store';
import { BranchState } from './branch.reducer';

export const selectBranchState = createFeatureSelector<BranchState>('branch');

export const selectBranchId = createSelector(
  selectBranchState,
  (state: BranchState) => state.branch_id
);